import React from 'react';
import { Container, Typography, Box, Paper, Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { STATIC_PAGES } from '../../utils/constants';

const blogPosts = [
  {
    slug: 'grow-your-channel',
    title: 'How to Grow Your Channel on IndeeClips',
    date: 'August 2026',
    category: 'Creator Tips',
    excerpt: 'Proven strategies to accelerate your channel growth with quality content, SEO, and community building.',
  },
  {
    slug: 'video-editing-tools',
    title: 'Best Video Editing Tools for Indian Creators',
    date: 'August 2026',
    category: 'Creator Tips',
    excerpt: 'From free mobile apps to professional desktop software—find the perfect editing tool for your budget and skill level.',
  },
  {
    slug: 'engaging-thumbnails',
    title: 'Creating Engaging Thumbnails: A Complete Guide',
    date: 'August 2026',
    category: 'Creator Tips',
    excerpt: 'Master the art and science of thumbnails that get clicks with design principles, tools, and real-world examples.',
  },
  {
    slug: 'video-seo-tips',
    title: 'Video SEO Tips for Maximum Views',
    date: 'August 2026',
    category: 'Creator Tips',
    excerpt: 'Optimize your titles, descriptions, and tags to dominate search results and suggested videos on IndeeClips.',
  },
  {
    slug: 'personal-brand',
    title: 'Building Your Personal Brand as a Creator',
    date: 'August 2026',
    category: 'Creator Tips',
    excerpt: 'Develop a unique brand that makes you recognizable, memorable, and irreplaceable to your audience.',
  },
  {
    slug: 'monetization-strategies',
    title: 'Monetization Strategies for Content Creators',
    date: 'August 2026',
    category: 'Creator Tips',
    excerpt: 'Diversify your income with sponsorships, digital products, services, and membership—without waiting for platform ads.',
  },
  {
    slug: 'copyright-fair-use',
    title: 'How to Handle Copyright and Fair Use',
    date: 'August 2026',
    category: 'Creator Tips',
    excerpt: 'Navigate copyright law safely, protect your content from theft, and understand fair dealing in India.',
  },
  {
    slug: 'viral-short-content',
    title: 'Creating Viral Short-Form Content',
    date: 'August 2026',
    category: 'Creator Tips',
    excerpt: 'Unlock the formula behind viral clips with hooks, formats, and posting strategies that drive massive reach.',
  },
  {
    slug: 'understanding-analytics',
    title: 'Analytics: Understanding Your Audience',
    date: 'August 2026',
    category: 'Creator Tips',
    excerpt: 'Use data to make smarter content decisions—learn which metrics matter and how to track channel growth.',
  },
  {
    slug: 'collaboration-tips',
    title: 'Collaboration Tips for Creators',
    date: 'August 2026',
    category: 'Creator Tips',
    excerpt: 'Find the right partners, pitch collaborations that get yes, and execute projects that benefit everyone involved.',
  },
  {
    slug: 'discover-content',
    title: 'How to Discover New Content on IndeeClips',
    date: 'August 2026',
    category: 'Viewer Guide',
    excerpt: "Unlock every discovery tool—from homepage recommendations to search filters—and find content you'll love.",
  },
  {
    slug: 'manage-subscriptions',
    title: 'Managing Your Subscriptions and Notifications',
    date: 'August 2026',
    category: 'Viewer Guide',
    excerpt: 'Subscribe strategically, control notifications, and keep your viewing experience organized and enjoyable.',
  },
  {
    slug: 'hidden-features',
    title: "IndeeClips Features You Didn't Know About",
    date: 'August 2026',
    category: 'Viewer Guide',
    excerpt: 'Hidden shortcuts, settings, and tools that dramatically improve your IndeeClips viewing experience.',
  },
  {
    slug: 'report-content',
    title: 'How to Report Inappropriate Content',
    date: 'August 2026',
    category: 'Viewer Guide',
    excerpt: 'Keep IndeeClips safe—learn when and how to report videos, channels, and comments that violate policies.',
  },
  {
    slug: 'parental-controls',
    title: 'Parental Controls and Safety Features',
    date: 'August 2026',
    category: 'Viewer Guide',
    excerpt: 'Protect kids with content filters, supervised accounts, and screen time management tools for safer viewing.',
  },
  {
    slug: 'indeeclips-vs-youtube',
    title: 'IndeeClips vs YouTube: What Makes Us Different',
    date: 'August 2026',
    category: 'Platform News',
    excerpt: 'Discover how IndeeClips stands apart with India-first approach, creator-friendly policies, and transparent algorithm.',
  },
  {
    slug: 'future-digital-content',
    title: 'The Future of Indian Digital Content',
    date: 'August 2026',
    category: 'Platform News',
    excerpt: 'Regional languages, hyperlocal stories, and AI-powered creation—explore where Indian content is headed by 2030.',
  },
  {
    slug: 'roadmap-2026',
    title: "IndeeClips 2026 Roadmap: What's Coming Next",
    date: 'August 2026',
    category: 'Platform News',
    excerpt: 'Full transparency on upcoming features—live streaming, monetization, multi-language support, and offline downloads.',
  },
  {
    slug: 'behind-the-scenes',
    title: 'Behind the Scenes: How IndeeClips Works',
    date: 'August 2026',
    category: 'Platform News',
    excerpt: 'Pull back the curtain on video streaming technology, CDNs, recommendation algorithms, and infrastructure powering IndeeClips.',
  },
  {
    slug: 'success-stories',
    title: 'Success Stories: Indian Creators on IndeeClips',
    date: 'August 2026',
    category: 'Platform News',
    excerpt: 'Meet creators who quit their jobs and turned IndeeClips into careers—from Bhojpuri cooking to Telugu tech tutorials.',
  },
  {
    slug: 'regional-language-content',
    title: 'The Rise of Regional Language Content in India',
    date: 'August 2026',
    category: 'Industry Insights',
    excerpt: '70% of Indian internet users prefer regional languages—explore the shift from English-first to Bharat-first content.',
  },
  {
    slug: 'streaming-technology',
    title: 'Video Streaming Technology Explained',
    date: 'August 2026',
    category: 'Industry Insights',
    excerpt: 'How do platforms deliver smooth 4K streaming on 4G? Demystifying codecs, CDNs, adaptive bitrate, and live streaming tech.',
  },
  {
    slug: 'recommendation-algorithms',
    title: 'How Video Recommendation Algorithms Work',
    date: 'August 2026',
    category: 'Industry Insights',
    excerpt: 'Understand the machine learning behind personalized feeds—watch time, CTR, and engagement metrics that drive recommendations.',
  },
  {
    slug: 'internet-trends-india',
    title: 'Internet Trends in Rural India: The Next 500 Million',
    date: 'August 2026',
    category: 'Industry Insights',
    excerpt: 'Rural Bharat represents the largest untapped internet market—explore device usage, content preferences, and growth opportunities.',
  },
  {
    slug: 'free-video-platforms',
    title: 'The Economics of Free Video Platforms',
    date: 'August 2026',
    category: 'Industry Insights',
    excerpt: 'How do "free" platforms like YouTube and IndeeClips make money? Break down ad revenue, data monetization, and infrastructure costs.',
  },
  {
    slug: 'how-to-upload-videos',
    title: 'How to Upload Videos on IndeeClips',
    date: 'June 2026',
    category: 'Creators',
    excerpt: 'A step-by-step guide to uploading your first video on IndeeClips and reaching thousands of Indian viewers.',
  },
  {
    slug: 'video-guidelines',
    title: 'Video Guidelines — What You Can and Cannot Upload',
    date: 'June 2026',
    category: 'Policy',
    excerpt: 'Everything you need to know about our content policies and what types of videos are allowed on IndeeClips.',
  },
  {
    slug: 'indian-creators',
    title: 'IndeeClips for Indian Creators — Grow Your Audience',
    date: 'May 2026',
    category: 'Creators',
    excerpt:
      'How Indian content creators are using IndeeClips to reach new audiences and build their channels from scratch.',
  },
  {
    slug: 'video-monetization',
    title: 'Video Monetization on IndeeClips — Earn from Your Content',
    date: 'May 2026',
    category: 'Monetization',
    excerpt: 'Learn how creators can earn revenue from their videos on IndeeClips through our monetization program.',
  },
  {
    slug: 'community-rules',
    title: 'Community Rules — Building a Positive Platform',
    date: 'April 2026',
    category: 'Community',
    excerpt:
      'Our community guidelines for viewers and creators to ensure IndeeClips remains a safe and positive space for everyone.',
  },
];

const Blog: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Box sx={{ minHeight: '100vh' }}>
      <Box
        sx={{
          background: (theme) =>
            `linear-gradient(160deg, ${theme.palette.background.default} 0%, ${theme.palette.background.paper} 100%)`,
          borderBottom: 1,
          borderColor: 'divider',
          py: 8,
          px: 3,
        }}
      >
        <Container maxWidth="lg">
          <Typography variant="overline" color="primary" sx={{ fontWeight: 600, letterSpacing: 3 }}>
            Blog
          </Typography>
          <Typography variant="h2" component="h1" sx={{ my: 2, fontWeight: 700 }}>
            {t('blog.title')}
          </Typography>
          <Typography variant="h6" color="text.secondary" sx={{ fontWeight: 300, maxWidth: '560px' }}>
            {t('blog.subtitle')}
          </Typography>
        </Container>
      </Box>

      <Container maxWidth="md" sx={{ py: 8 }}>
        <Box sx={{ display: 'grid', gap: 3 }}>
          {blogPosts.map((post) => (
            <Paper
              key={post.slug}
              elevation={0}
              onClick={() => navigate(`/blog/${post.slug}`)}
              sx={{
                p: 4,
                border: 1,
                borderColor: 'divider',
                borderRadius: 2,
                cursor: 'pointer',
                transition: 'all 0.2s',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'flex-start',
                '&:hover': {
                  borderColor: 'primary.main',
                  transform: 'translateX(4px)',
                },
              }}
            >
              <Box sx={{ flex: 1 }}>
                <Chip
                  label={post.category}
                  size="small"
                  color="primary"
                  variant="outlined"
                  sx={{
                    mb: 2,
                    fontWeight: 600,
                    fontSize: '11px',
                    letterSpacing: '1px',
                    textTransform: 'uppercase',
                  }}
                />
                <Typography variant="h5" sx={{ mb: 1.5, fontWeight: 600 }}>
                  {post.title}
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 1, lineHeight: 1.7 }}>
                  {post.excerpt}
                </Typography>
                <Typography variant="caption" color="text.secondary" sx={{ fontSize: '12px' }}>
                  {post.date}
                </Typography>
              </Box>
              <Typography sx={{ color: 'primary.main', fontSize: '20px', ml: 2, flexShrink: 0 }}>→</Typography>
            </Paper>
          ))}
        </Box>
      </Container>
    </Box>
  );
};

export default Blog;
